import React from 'react';
import { BrowserRouter, Route, Routes as RouterRoutes } from "react-router";
import PrivateRoute from '../components/PrivateRoute';
import Contact from './Contact';
import DonneesPersonnelles from './DonneesPersonnelles';
import EspacePersonnel from './EspacePersonnel';
import HomePage from './HomePage';
import MentionsLegales from './MentionsLegales';
import NotFoundPage from './NotFoundPage';

function Routes() {
    return (
      <BrowserRouter>
        <RouterRoutes>
        <Route path="/"  element={<HomePage />} />
        <Route path="/mentions-legales"  element={<MentionsLegales />} />
        <Route path="/donnees-personnelles"  element={<DonneesPersonnelles />} />
        <Route path="/contact"  element={<Contact />} />
        {/* Private Route*/}
        <Route path="/espace-personnel"  element={
            <PrivateRoute><EspacePersonnel /></PrivateRoute>} />
        <Route element={<NotFoundPage />} />
     </RouterRoutes>
     </BrowserRouter>
    );
  }


export default Routes;
